/**
 * Attempts to load a script at a given URL, returning the promise.
 * @param url URL of the package being loaded.
 * @returns A resolved or rejected promise.
 */
export const loadScript = (url: string) => {
  return new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = url;
    script.async = true;

    script.onload = () => resolve(script);
    script.onerror = () => reject(new Error(`Failed to load script: ${url}`));

    document.head.appendChild(script);
  });
};
